<script setup lang="ts">
import { odsIcon, IconName, IconFolder } from '../odsIcon';
import { AsidePosition } from '../../tokens'
import { ButtonType, ButtonColor, ButtonSize } from './odsButton.ts';
import { PropType, useSlots, useAttrs, reactive, nextTick } from 'vue';

const emit = defineEmits(['mouseover', 'mouseout', 'blur', 'click', 'routeErr'])

const props = defineProps({
    type:{
        type: String as PropType<typeof ButtonType[keyof typeof ButtonType]>,
        default: ButtonType.Filled
    },
    color:{
        type: String as PropType<typeof ButtonColor[keyof typeof ButtonColor]>,
        default: ButtonColor.Primary
    },
    size:{
        type: String as PropType<typeof ButtonSize[keyof typeof ButtonSize]>,
        default: ButtonSize.Medium
    },
    disabled:{
        type: Boolean,
        default: false
    },
    loading:{
        type: Boolean,
        default: false
    },
    label:{
        type: String,
        default: ''
    },
    icon: {
        type: String as PropType<typeof IconName[keyof typeof IconName] | String>,
        default: ''
    },
    iconPosition: {
        type: String as PropType<typeof AsidePosition[keyof typeof AsidePosition] | String>,
        default: AsidePosition.Default
    },
    iconFolder: {
        type: String as PropType<IconFolder>,
        default: IconFolder.Default
    },
})

const slots = useSlots()

const attrs = reactive(
    {
        ...useAttrs(),
        onClick: (event : Event) => clickButton(event),
        onBlur: (event : Event) => blurButton(event),
        onMouseover: (event : Event) => mouseover(event),
        onMouseout: (event : Event) => mouseout(event)
    }
)

let iconClass = ''
if(slots.hasOwnProperty('before') || (props.icon !== '' && props.iconPosition == AsidePosition.Before)){
    iconClass = 'icon-left'
}
if(slots.hasOwnProperty('after') || (props.icon !== '' && props.iconPosition == AsidePosition.After)){
    iconClass = 'icon-right'
}
if((slots.hasOwnProperty('before') || slots.hasOwnProperty('after') || (props.icon !== '' && props.iconPosition == AsidePosition.Before) || (props.icon !== '' && props.iconPosition == AsidePosition.After)) && props.label === ''){
    iconClass = 'icon-only'
}



function mouseover(event : Event){
    emit('mouseover', event)
}
function mouseout(event : Event){
    emit('mouseout', event)        
}
function blurButton(event : Event){
    emit('blur',event)
}
function clickButton(event : Event){
    nextTick(() => {
        if(props.disabled || props.loading){
        return
        }
        emit('click', event)
    });
}

</script>

<template>
    <button
        v-bind="attrs"
        class="ods-button" 
        :class="[type, color, size, iconClass, {disabled, loading}]" 
        :disabled="disabled || loading" 
    >
        <slot name="before">
            <odsIcon :name="icon" :folder="iconFolder" v-if="icon && iconPosition == AsidePosition.Before"/>
        </slot>
        <slot>
            <span class="label" v-if="label !== ''" v-html="label"></span>
        </slot>
        <slot name="after">
            <odsIcon :name="icon" :folder="iconFolder" v-if="icon && iconPosition == AsidePosition.After"/>
        </slot>
        <span class="loading-container">
            <span class="stars">
                <span class="shooting-star"></span>
                <span class="shooting-star"></span>
                <span class="shooting-star"></span>
                <span class="shooting-star"></span>
                <span class="shooting-star"></span>
                <span class="shooting-star"></span>
                <span class="shooting-star"></span>
            </span>
            <span class="loading-container-inner">
                <span class="loader"></span>
            </span>
        </span>
    </button>
</template>

<style lang="scss" src="./odsButton.scss">
</style>